<template>
  <div class="practice-student-list-page">
    <TitleBar title="训练表现" back />
    <div class="main">
      <training-overview-info :training="training"></training-overview-info>
      <training-clazz-static-info
        :clazz-summary-items="clazzSummaryItems"
        :clazz-options="clazzOptions"
        :value="clazzId"
        @change="updateClazzId"
      ></training-clazz-static-info>

      <list-page class="list-page" :data="studentList" :limit="query.limit">
        <el-table-column label="学生姓名" prop="name" />
        <el-table-column label="年级班级" prop="class_name" />

        <el-table-column label="性别" prop="gender" />
        <el-table-column label="完成情况">
          <template v-slot="{ row }">
            <div class="completion-status">
              <div :class="['status', statusClass(row.completion_status)]"></div>
              {{ row.completion_status }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="action" label="更多操作" align="center">
          <template v-slot="{ row }">
            <el-button type="text" @click="navToDetail(row.user_id)">详情</el-button>
          </template>
        </el-table-column>
      </list-page>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import { Clazz, IClazzStaticSummary, IStudentStaticSummary, ITrainingListItem } from 'kuaidong-model'
import TitleBar from '@/components/TitleBar.vue'
import { SchoolUtil, UnitUtil } from 'kuaidong-lib'
import { AWinter2023 } from 'kuaidong-api'
import ListPage from '@/components/ListPage.vue'
import TrainingOverviewInfo from '@/views/special-skill/components/TrainingOverviewInfo.vue'
import TrainingClazzStaticInfo from '@/views/special-skill/components/TrainingClazzStaticInfo.vue'
import { NewCourseLiveService } from 'kuaidong-service'

@Component({
  components: {
    TitleBar,
    ListPage,
    TrainingOverviewInfo,
    TrainingClazzStaticInfo,
  },
})
export default class PracticeStudentListPage extends BasePage {
  @Prop({ type: Object, required: true })
  training!: ITrainingListItem

  @Prop({ type: String, required: true })
  from!: 'KNOWLEDGE' | 'SPECIAL_EXERCISE'

  @Prop({ type: String, required: true })
  challengeClassId!: string

  @Prop({ type: Array, required: true })
  clazzOptions!: {
    value: number
    label: string
    challenge_id: string
    challenge_class_id: string
  }[]

  query = {
    limit: 20,
    offset: 0,
  }
  staticInfo: IClazzStaticSummary | null = null
  summaryItems: IStudentStaticSummary[] = []
  clazzId: number | null = null
  currentChallengeClassId = this.challengeClassId

  get clazzSummaryItems() {
    if (this.staticInfo === null) {
      return [
        { value: '-', title: '学生人数' },
        { value: '-', title: '已完成' },
        { value: '-', title: '未完成' },
        { value: '-', title: '完成率' },
      ]
    } else {
      return [
        { value: this.staticInfo?.students_count, title: '学生人数' },
        { value: this.staticInfo?.completion_count, title: '已完成' },
        { value: this.staticInfo?.uncompleted_count, title: '未完成' },
        { value: this.staticInfo.completion_rate, title: '完成率' },
      ]
    }
  }

  get studentList() {
    if (this.summaryItems) {
      return this.summaryItems.map((item) => {
        return {
          user_id: item.student_vo.user_id,
          name: this._show_student_name(item.student_vo as any),
          class_name: item.class_vo.note_name || item.class_vo.name,
          gender: item.student_vo.gender === 'M' ? '男' : '女',
          completion_status: item.completion_status,
        }
      })
    }
    return []
  }

  get service() {
    return NewCourseLiveService
  }

  get currentClazz() {
    return this.clazzOptions.find((option) => {
      return option.challenge_class_id === this.currentChallengeClassId
    })
  }

  showClazzName(clazz: Clazz) {
    return clazz.note_name || clazz.name || SchoolUtil.buildClazzName(clazz.grade_no, clazz.class_no)
  }

  statusClass(status: string) {
    if (status === '未完成' || status === '未开始') {
      return 'un-finished'
    } else if (status === '完成') {
      return 'finished'
    } else if (status === '进行中') {
      return 'in-process'
    } else {
      return ''
    }
  }

  formatRate(rate: number) {
    return UnitUtil.percent(rate)
  }

  async created() {
    if (this.currentClazz) {
      this.clazzId = this.currentClazz.value
    }

    this.fetchStudentList()
    this.fetchClazzStaticInfo()
  }

  async fetchClazzStaticInfo() {
    this.staticInfo = await AWinter2023.trainingClassSummary(this.training.group_id, this.clazzId)
  }

  async fetchStudentList() {
    this.summaryItems = await AWinter2023.classStudentList(this.currentChallengeClassId)
  }

  updateClazzId(clazzId: number) {
    this.clazzId = clazzId
    const targetClazz = this.clazzOptions.find((option) => {
      return option.value === this.clazzId
    })
    this.currentChallengeClassId = targetClazz ? targetClazz.challenge_class_id : ''
    this.fetchStudentList()
    this.fetchClazzStaticInfo()
  }

  navToDetail(userId: string) {
    this.$router.push({
      name: 'winter_2023_question_student_training_record_detail',
      query: {
        userId: userId,
        chanllengeClassID: this.currentChallengeClassId,
      },
    })
  }
}
</script>
<style lang="less">
.practice-student-list-page {
  > .main {
    padding: 22px 24px;
    background: #fff;

    > .list-page {
      margin-top: 24px;
      padding: 0;
      > .el-table {
        > .el-table__body-wrapper {
          > .el-table__body {
            > tbody {
              > .el-table__row {
                > td {
                  > .cell {
                    > .completion-status {
                      display: flex;
                      align-items: center;
                      > .status {
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        margin-right: 4px;
                        &.un-finished {
                          background: #f24b53;
                        }
                        &.finished {
                          background: #3bb528;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
